export default __webpack_public_path__ + "805f95bae87efff0f453fd5ca082cc5c.png";